import React from "react";
import { Link } from "react-router-dom";
import StarRating from "./StarRating";
import { ArrowRight } from "lucide-react";
import { COMPANY_LIST } from "../data/companies";
import { useCompany } from "../context/CompanyContext";

export default function SimilarCompanies() {
  const { company } = useCompany();
  const same = COMPANY_LIST.filter(
    (c) => c.category === company.category && c.slug !== company.slug
  ).slice(0, 6);
  const fill = COMPANY_LIST.filter(
    (c) => c.slug !== company.slug && !same.find((s) => s.slug === c.slug)
  ).slice(0, 6 - same.length);
  const list = [...same, ...fill];

  return (
    <section className="bg-[#f5f7f8] border-t border-gray-200">
      <div className="max-w-[1200px] mx-auto px-4 py-8">
        <h2 className="text-lg md:text-2xl font-bold text-gray-900 mb-5">
          Companies Similar to {company.name}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 md:gap-3">
          {list.map((c) => (
            <Link
              key={c.slug}
              to={`/company/${c.slug}`}
              className="bg-white border border-gray-200 rounded-md p-3 md:p-4 hover:shadow-md hover:border-[#007a8a]/40 transition-all flex flex-col items-center text-center"
            >
              <div
                className="w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center text-white font-bold mb-2 text-xs md:text-base"
                style={{ backgroundColor: c.color }}
              >
                {c.initials}
              </div>
              <div className="text-xs md:text-sm font-semibold text-gray-800 truncate w-full">{c.name}</div>
              <div className="mt-1"><StarRating value={c.rating} size={10}/></div>
              <div className="text-[10px] md:text-xs text-gray-500 mt-1">{c.totalReviews.toLocaleString()} reviews</div>
            </Link>
          ))}
        </div>
        <Link to="/browse" className="inline-flex items-center gap-1 text-[#007a8a] hover:underline text-sm font-medium mt-4">
          See more {company.category} businesses <ArrowRight size={14}/>
        </Link>
      </div>
    </section>
  );
}
